export default "__VITE_ASSET__9519c97b__"